@let cardConfig = card();

<div layout layout-flex-1-1 padding (click)="cardClick.emit(cardConfig.action)">
  <div margin-right>
    <rt-icon
      [name]="cardConfig.icon"
      size="medium"
      [hasAutoHeight]="true"
      colorToken="colorIconPrimaryDefault"
    />
  </div>
  <div layout-vertical>
    <rt-heading>{{ cardConfig.heading }}</rt-heading>
    <span [innerHTML]="cardConfig.subheading"></span>
  </div>
</div>
